(function () {
  let observer = null;
  let loading = false;

  function init() {
    const sentinel = document.getElementById('infinite-scroll-sentinel');
    if (!sentinel) return;

    if (observer) observer.disconnect();

    loading = false;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !loading) {
            loadNextPage();
          }
        });
      },
      { rootMargin: '400px' }
    );

    observer.observe(sentinel);
  }

  function loadNextPage() {
    const sentinel = document.getElementById('infinite-scroll-sentinel');
    if (!sentinel) return;

    const currentPage = parseInt(sentinel.dataset.currentPage, 10);
    const totalPages = parseInt(sentinel.dataset.totalPages, 10);

    if (currentPage >= totalPages) {
      if (observer) observer.disconnect();
      sentinel.remove();
      return;
    }

    loading = true;
    const spinner = sentinel.querySelector('.infinite-scroll-spinner');
    if (spinner) spinner.style.display = 'flex';

    const nextPage = currentPage + 1;
    const sectionId = sentinel.dataset.sectionId;
    const collectionUrl = sentinel.dataset.collectionUrl;

    // Preserve any existing query params (filters, sort)
    const params = new URLSearchParams(window.location.search);
    params.set('page', nextPage);
    params.set('section_id', sectionId);

    const url = collectionUrl + '?' + params.toString();

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid > li');
        const grid = document.getElementById('product-grid');

        if (newItems.length > 0 && grid) {
          newItems.forEach((item) => grid.appendChild(item));
        }

        // Update sentinel for next page
        sentinel.dataset.currentPage = nextPage;

        if (spinner) spinner.style.display = 'none';
        loading = false;

        // If we've reached the last page, clean up
        if (nextPage >= totalPages) {
          if (observer) observer.disconnect();
          sentinel.remove();
        }
      })
      .catch(() => {
        if (spinner) spinner.style.display = 'none';
        loading = false;
      });
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', init);

  // Re-initialize when facets.js replaces the grid (filter/sort changes)
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    new MutationObserver(() => {
      init();
    }).observe(gridContainer, { childList: true, subtree: false });
  } else {
    // If gridContainer isn't ready yet, wait for DOM
    document.addEventListener('DOMContentLoaded', () => {
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        new MutationObserver(() => {
          init();
        }).observe(container, { childList: true, subtree: false });
      }
    });
  }
})();
